/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {UnlinkAccountAdminRequest} from '@cash-web/protos/squareup/cash/janus/api/admin/AccountHolderAdminProtos.pb'
import {UnlinkAccountAdminResponse} from '@cash-web/protos/squareup/cash/janus/api/admin/AccountHolderAdminProtos.pb'


export const unlinkAccountAdmin = (request: UnlinkAccountAdminRequest, options?: CashRequestOptions) => post<UnlinkAccountAdminRequest, UnlinkAccountAdminResponse>("/2.0/cash/unlink-account-admin", request, {...options, rejectOnError: true })